var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 14,
    viewBox: "0 0 19 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.28 6.74 3.081.293l1.643 4.4L.171 6.74l4.554 2.048-1.643 4.4z"
  })));
};
export default SvgArrowRight;